### CONFIG SCRIPTS INIT GLOBAL ###
import AOS from 'aos';
import { Tooltip } from 'bootstrap';

do ->
  'use strict'

  $(document).on 'turbolinks:load', ->
    ### LOAD TOOLTIPS ###
    tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map((tooltipTriggerEl) ->
      new (Tooltip)(tooltipTriggerEl)
    )

    # INIT AOS ANIMATION
    AOS.init();
    return

  # END BLOCK SCRIPT
  return
